import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { stackItems } from '../data/content';
export function ValueStack() {
  return <section className="w-full border-y border-ink/10 bg-oat/60" data-id="element-137" data-mp="1q8crso7f9589">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-138" data-mp="1qa5yu4ly5rgs">
        <SectionLabel data-id="element-139" data-mp="1uapz3h1thb75">El pack completo</SectionLabel>
        <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-140" data-mp="2hzsnd7qyi2am">
          Al inscribirte hoy, te llevás la experiencia completa
        </h2>

        <ul className="mt-8 divide-y divide-ink/10 overflow-hidden rounded-2xl border border-ink/10 bg-cream sm:mt-10 sm:rounded-3xl" data-id="element-141" data-mp="2mxu8rzbuudp9">
          {stackItems.map((item, index) => <motion.li key={item.name} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`flex items-start justify-between gap-3 p-4 sm:gap-5 sm:p-6 ${item.isMain ? 'bg-sage/10' : ''}`} data-id="element-142" data-mp="2d798m7gj9148" data-mpi={index}>
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-143" data-mp="2356961g4px1h">
                <span className="text-base sm:text-lg" aria-hidden="true" data-id="element-144" data-mp="236hazvq0kupy">
                  {item.label}
                </span>
                <span className={`font-sans text-[14px] leading-snug sm:text-base ${item.isMain ? 'font-semibold text-ink' : 'font-normal text-ink/75'}`} data-id="element-145" data-mp="2c5umetxp7tdb">
                  {item.name}
                </span>
              </div>
              <span className="shrink-0 font-display text-sm text-ink/50 line-through sm:text-base" data-id="element-146" data-mp="2h5z60stwl47r">
                {item.value}
              </span>
            </motion.li>)}
        </ul>

        <div className="mt-5 flex items-baseline justify-between gap-3 rounded-2xl bg-moss px-5 py-4 text-cream sm:mt-6 sm:px-6 sm:py-5" data-id="element-147" data-mp="mry6s6ufyf75">
          <span className="font-sans text-[10px] uppercase tracking-[0.18em] text-cream/70 sm:text-xs sm:tracking-[0.22em]" data-id="element-148" data-mp="2mv8wic9c7se5">
            Valor total
          </span>
          <span className="font-display text-xl sm:text-2xl" data-id="element-149" data-mp="2vt2ppebt25x3">$43.500 ARS</span>
        </div>
      </div>
    </section>;
}